import Groups from './Groups';
import SessionsEditor from './SessionsEditor';
import { SubPagesLayout } from '../common';
import { Header, Icon, Message } from '../../components';
import ormActions from '../../orm/actions';
import { groupsSelector, sessionsSelector } from '../../orm/selectors';
import { bickActions } from '../../common';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, map } from 'lodash';

class Schedule extends Component {
  render() {
    const { app, route, groups, sessions, actions } = this.props;

    const nonEmptyGroups = filter(groups, 'entries.length');
    const groupsMissingSession = filter(
      nonEmptyGroups,
      group => !group.session,
    );

    const Sessions = () => (
      <section>
        <Header as="h1">Sessions</Header>
        <p>
          {!groupsMissingSession.length && (
            <Icon key={1} name="checkmark" color="green" />
          )}
          {groupsMissingSession.length === nonEmptyGroups.length
            ? 'Groups have not been assigned into sessions yet.'
            : 'Groups have been assigned into sessions.'}
        </p>
        {![nonEmptyGroups.length, 0].includes(groupsMissingSession.length) && (
          <Message
            icon="warning circle"
            header="Groups are missing assignments into sessions!"
            content={[
              groupsMissingSession.length,
              ' groups: : ',
              map(
                groupsMissingSession,
                group => `${group.contest.title} ${group.letter}`,
              ).join(', '),
            ]}
            warning
          />
        )}
        <SessionsEditor
          id="schedule--sessions-editor"
          sessions={sessions}
          actions={actions.session}
          meta={{ groups, sessions }}
        />
      </section>
    );

    /*
    const Timetable = () => (
      <section>
        <Header as="h1">Timetable</Header>
        <p>Lorem ipsum dolor sit amet.</p>
      </section>
    );
    */

    return (
      <SubPagesLayout app={app} route={route}>
        {[
          { slug: '', title: 'Groups', component: Groups },
          { slug: 'sessions', title: 'Sessions', component: Sessions },
          //{ slug: 'groups', title: 'Groups', component: Groups },
          //{ slug: 'timetable', title: 'Timetable', component: Timetable },
        ]}
      </SubPagesLayout>
    );
  }
}

Schedule.slug = 'schedule';
Schedule.title = 'Schedule';

const mapStateToProps = ({ orm }) => ({
  groups: groupsSelector(orm),
  sessions: sessionsSelector(orm),
});

const mapDispatchToProps = dispatch => ({
  actions: bickActions(ormActions, ['session'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Schedule);



// WEBPACK FOOTER //
// ./src/pages/Schedule/Schedule.js